import React, { type PropsWithChildren, useEffect } from 'react';

export const DEFAULT_HUBSPOT_PORTAL_ID = '21902860';

const CLIENT_APP_HOSTNAME = 'app.hellodarwin.com';
const HUBSPOT_SCRIPT_ID = 'hs-script-loader';

type HubspotQueueCommand = [string, ...unknown[]];

declare global {
  interface Window {
    _hsq?: HubspotQueueCommand[];
  }
}

export interface HubspotTrackingProviderProps extends PropsWithChildren {
  enabled?: boolean;
  portalId?: string;
}

const isClientAppHost = () =>
  typeof window !== 'undefined' &&
  window.location.hostname === CLIENT_APP_HOSTNAME;

export const HubspotTrackingProvider: React.FC<
  HubspotTrackingProviderProps
> = ({
  children,
  enabled = isClientAppHost(),
  portalId = DEFAULT_HUBSPOT_PORTAL_ID,
}) => {
  useEffect(() => {
    if (!enabled || !portalId) return;

    window._hsq = window._hsq || [];

    if (document.getElementById(HUBSPOT_SCRIPT_ID)) return;

    const script = document.createElement('script');
    script.id = HUBSPOT_SCRIPT_ID;
    script.async = true;
    script.defer = true;
    script.src = `https://js.hs-scripts.com/${portalId}.js`;
    document.head.appendChild(script);
  }, [enabled, portalId]);

  return <>{children}</>;
};

export default HubspotTrackingProvider;
